var file_upload_viewer_default = {
  "fontElementMap": "kjrMq",
  "file_upload_container": "_6kQCq",
  "file_upload_link": "C-14Y",
  "file_upload_error_container": "Yrf-p",
  "file_upload_file_info": "_5I-xz",
  "file_upload_type_icon": "_2YqPX",
  "file_upload_status_icon_container": "f8-LP",
  "file_upload_status_icon": "_91M-9",
  "file_upload_description": "eDA63",
  "file_upload_name_container": "Kww6a",
  "file_upload_name": "FiZaP",
  "file_upload_extension": "_66I2C",
  "file_loader_icon": "J7kfr",
  "file_upload_icon_frame": "MOYhZ",
  "file_upload_icon_background": "USlHt"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
